<template>
    <div class="modal nb-modal-mask" style="display:block" @keyup.esc="closeModal()">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document" style="overflow-y: initial !important">
            <div class="modal-content">
                <div class="modal-header" :style="`background:${params_pdv.colors.bg_top_bottom ? params_pdv.colors.bg_top_bottom : '#174b79'}!important;`">
                    <h4 class="def-title" :style="`color:${params_pdv.colors.fc_top_bottom ? params_pdv.colors.fc_top_bottom : 'white;'}!important`" id="exampleModalLabel">
                        Informar Quantidade
                    </h4>
                    <button @click="closeModal()"  :style="`color:${params_pdv.colors.fc_top_bottom ? params_pdv.colors.fc_top_bottom : 'white;'}!important`" class="close" >
                        <span >&times;</span>
                    </button>
                </div>
                <div class="modal-body pt-3 d-flex justify-content-center" style="height: 180px!important ;max-height: 100%; overflow-y: auto">

                    <!-- CLIENTE SELECIONADO - EXIBE INFORMACOES DE CRÉDITO -->
                    <div class="border d-flex justify-content-center align-items-center col-12" style="padding: 10px;">
                        <div class="row col-5">
                            <small class="lbl-edit">Quantidade</small>
                            <input type="number" v-model.number="quantidade" class="form-control" ref="qtd" @keyup.enter="changeToNextEl()">
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <v-button danger label="Cancelar" @click="closeModal()" />
                    <v-button nbBtdef label="Confirmar" ref="qtdConfirmButton" @click="handleConfirmQtd()" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        params_pdv:{
        type: Object,
        default: []
        }

    },
    data(){
        return{
            quantidade: 1
        }
    },
    methods:{
        handleConfirmQtd(){
            let qtdInformada = this.quantidade
            this.$emit('getQtdInformada', qtdInformada)
            this.closeModal()
        },
        changeToNextEl(){
            this.$nextTick(function (){
                this.$refs.qtdConfirmButton.focus()
            })
        },
        closeModal(){
            this.$emit('close')

        }
    },
    created(){
        this.$nextTick(function (){
           this.quantidade = 1
           this.$nextTick(function (){
               this.$refs.qtd.focus()
           })
        })


        window.addEventListener('keyup', function (event){
            if (event.keyCode == 27){
                this.closeModal()
            }
        })
    },

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms-varejo/varejo-quantidade-item.vue